import { createStorage } from '../cache/index';
import { RecordItem } from '@/views/mine/types';
const { get, set, remove } = createStorage();

export function setRecord(record: RecordItem) {
  set('default-record', record);
}
export function getRecord(): RecordItem {
  return get('default-record');
}
export function removeRecord() {
  remove('default-record');
}
export function setCurRecord(record: RecordItem) {
  set('current-record', record);
}
export function getCurRecord(): RecordItem {
  return get('current-record');
}
export function removeCurRecord() {
  remove('current-record');
}
